import { ActivityComponentType } from '@stackflow/react'
import useTranslation from '../../../modules/i18n/useTranslation'
import { BookMarkedMaterials } from '../../../pages/[lang]/portal/my-ringle/materials/bookmark'
import { useMaterialsStack } from '../../../pages/[lang]/webview/materials'
import WebviewStackContainer from '../common/WebviewStackContainer'

const MaterialsBookmarkActivity: ActivityComponentType = () => {
  const { t } = useTranslation()
  const { useMaterialsFlow } = useMaterialsStack()
  const { pop } = useMaterialsFlow()

  return (
    <WebviewStackContainer height="52px" onBack={pop}>
      <BookMarkedMaterials />
    </WebviewStackContainer>
  )
}

export default MaterialsBookmarkActivity
